import React from 'react';
import Card from '../../../../components/ui/Card';
import { ShoppingBag, Ticket, Music } from 'lucide-react';

const TopProductsWidget = ({ products = [] }) => {
  // Use mock data if products is empty (for demo purposes)
  const displayProducts = products.length > 0 ? products : [
    {
      id: 1,
      name: "Unity Concert Ticket",
      type: "Event",
      revenue: 15400,
      sales: 124,
      icon: Ticket,
      color: "bg-blue-100 text-blue-600"
    },
    {
      id: 2,
      name: "Signature Hoodie",
      type: "Merch",
      revenue: 8500,
      sales: 45,
      icon: ShoppingBag,
      color: "bg-pink-100 text-pink-600"
    },
    {
      id: 3,
      name: "Personalized Video",
      type: "Experience",
      revenue: 7500,
      sales: 3,
      icon: Music,
      color: "bg-purple-100 text-purple-600"
    }
  ];

  return (
    <Card className="h-full">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-bold text-slate-800">Top Products</h3>
        <span className="text-xs font-semibold text-green-600 bg-green-50 px-2 py-1 rounded-full">
          +12% vs last month
        </span>
      </div>
      <div className="space-y-4">
        {displayProducts.map((product, index) => (
          <div key={product.id} className="flex items-center gap-4 p-3 bg-slate-50 rounded-lg hover:bg-slate-100 transition-colors">
            <div className={`w-10 h-10 rounded-full flex items-center justify-center ${product.color}`}>
              {React.createElement(product.icon, { size: 20 })}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold text-slate-800 truncate">{product.name}</p>
              <p className="text-xs text-slate-500">{product.type} • {product.sales} sales</p>
            </div>
            <div className="text-right">
              <p className="text-sm font-bold text-slate-800">{product.revenue.toLocaleString()} ETB</p>
            </div>
          </div>
        ))}
      </div>
      <button className="w-full mt-4 py-2 text-sm text-slate-600 hover:text-purple-600 font-medium border-t border-slate-200">
        View All Products
      </button>
    </Card>
  );
};

export default TopProductsWidget;
